import React from 'react';
import CustomPagination from '../../components/CustomPagination';
import useLiveDataTable from '../../hooks/useLiveDataTable';
import { useGetAppliactionHistoryQuery } from '../../redux/services/DashboardService';
import moment from 'moment';

const ApplicationHistory = ({ id }) => {
    const {
        currentPage,
        perPage,
        q,
        searchQuery,
        setSearchQuery,
        handlePageChange,
        handlePerPageChange,
        handleSearchChange,
        onSearchKeyHandler
    } = useLiveDataTable();

    const { data: data2, isLoading, isFetching, refetch } = useGetAppliactionHistoryQuery(id)
    const history = data2?.response?.data?.data
    const total = data2?.response?.data?.total;

    const showStatusColor = (days) => {
        if (days == 0) {
            return 'bg-danger'
        } else if (days == 10) {
            return 'bg-warning'
        } else if (days == 20) {
            return 'bg-info'
        } else if (days == 30) {
            return 'bg-success'
        }
    }

    console.log('history', history)

    return (
        <>
            <div className="single-data mt-2">
                <h5 className="text-left">Application History</h5>


                <CustomPagination
                    isFetching={isFetching}
                    data={history}
                    total={total}
                    onChangePage={handlePageChange} // Handle page change
                    onChangeRowsPerPage={handlePerPageChange} // Handle per page change
                    paginationDefaultPage={currentPage} // Set the current page

                    columns={[
                        {
                            name: 'Driver Id',
                            selector: row => row.driver_id,
                            sortable: true,
                            width: '25%'
                        },
                        {
                            name: 'Message',
                            selector: row => row.message,
                            sortable: true,
                            width: '30%'
                        },
                        {
                            name: 'Created At',
                            selector: row => moment(row.created_at)?.format('YYYY-MM-DD HH:mm'),
                            sortable: true,
                            width: '30%'
                        },
                        // {
                        //     name: 'Actions',
                        //     cell: (row, i) => {
                        //         return (
                        //             <div className="hstack gap-1 fs-1">
                        //                 <button
                        //                     aria-label="view"

                        //                     className="btn btn-icon btn-sm btn-primary-light btn-wave waves-effect waves-light"
                        //                 >
                        //                     <i className="ri-eye-fill" />
                        //                 </button>
                        //                 <button
                        //                     aria-label="edit"
                        //                     // 

                        //                     className="btn btn-icon btn-sm btn-info-light btn-wave waves-effect waves-light"
                        //                 >
                        //                     <i className="ri-edit-line" />
                        //                 </button>
                        //                 <a
                        //                     aria-label="delete"

                        //                     className="btn btn-icon btn-sm btn-danger-light btn-wave waves-effect waves-light"
                        //                 >
                        //                     <i className="ri-delete-bin-7-line" />
                        //                 </a>
                        //             </div>
                        //         )
                        //     },
                        //     ignoreRowClick: true,
                        //     allowOverflow: true,
                        //     button: true,
                        //     width: '220px'
                        // },
                    ]}
                />
            </div>
        </>
    )
}

export default ApplicationHistory